import { types } from './types';

export const setGetProvidersAction = (payload) => {
  return {
    type: types.SET_GET_PROVIDERS,
    payload,
  }
}

export const setGetGamesAction = (payload) => {
  return {
    type: types.SET_GET_GAMES,
    payload,
  }
}

export const setGetGameByIdAction = (payload) => {
  return {
    type: types.SET_GET_GAME_BY_ID,
    payload,
  }
}

export const setGetProviderByIdAction = (payload) => {
  return {
    type: types.SET_GET_PROVIDER_BY_ID,
    payload,
  }
}